import type { Transition, Variants } from "framer-motion"

import { ASSISTANT_PANE_WIDTH } from "~components/outfitter-assistant/outfitter-assistant-constants"
import {
    MOTION_DURATION_S,
    MOTION_EASE,
    MOTION_SPRING,
} from "~components/shared/motion/motion-tokens"

const MS_PER_SECOND = 1000
const ASSISTANT_TRANSITION_DURATION_MS = MOTION_DURATION_S.base * MS_PER_SECOND
const ASSISTANT_STANDARD_EASING = `cubic-bezier(${MOTION_EASE.standard.join(
    ", "
)})`
const ASSISTANT_ENTER_TRANSITION = MOTION_SPRING.snappy
const ASSISTANT_EXIT_TRANSITION: Transition = {
    duration: MOTION_DURATION_S.base,
    ease: MOTION_EASE.standard,
}
export const ASSISTANT_HEADER_BUTTON_TRANSITION = [
    "max-width",
    "opacity",
    "margin-left",
]
    .map(
        (property) =>
            `${property} ${ASSISTANT_TRANSITION_DURATION_MS}ms ${ASSISTANT_STANDARD_EASING}`
    )
    .join(", ")

export const ASSISTANT_PANE_WIDTH_VARIANTS: Variants = {
    initial: { width: 0 },
    animate: {
        width: ASSISTANT_PANE_WIDTH,
        transition: ASSISTANT_ENTER_TRANSITION,
    },
    exit: {
        width: 0,
        transition: ASSISTANT_EXIT_TRANSITION,
    },
}

export const ASSISTANT_DESKTOP_PANEL_VARIANTS: Variants = {
    initial: { translateX: "100%" },
    animate: {
        translateX: 0,
        transition: ASSISTANT_ENTER_TRANSITION,
    },
    exit: {
        translateX: "100%",
        transition: ASSISTANT_EXIT_TRANSITION,
    },
}

export const ASSISTANT_BOTTOM_SHEET_VARIANTS: Variants = {
    initial: { translateY: "100%" },
    animate: {
        translateY: 0,
        transition: ASSISTANT_ENTER_TRANSITION,
    },
    exit: {
        translateY: "100%",
        transition: ASSISTANT_EXIT_TRANSITION,
    },
}
